import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Page404() {
    const navigate = useNavigate();

    return (
        <div className="card">
            <div className="card-header">
                Page introuvable
            </div>
            <div className="card-body">
                <button
                    onClick={() => navigate("/")}
                    className="btn btn-link"
                >
                    Retour à l'accueil
                </button>
            </div>
        </div>
    );
}
